export enum Direction {
    IN = 'IN',
    OUT = 'OUT'
}

export enum Orientation {
    RIGHT = 'right',
    LEFT = 'left',
    NORMAL = 'normal',
    INVERTED = 'inverted'
}

export enum Resolution {
    FULL_HD = 'Full HD',
    FOUR_K = '4K'
}

export enum ConnectionType {
    DIRECT_LINK = '192.168.5.1',
    CONNECTIVITY_BOX = '192.168.2.1',
    LOT_NETWORK = '192.168.10.1'
}
